import { Briefcase, GraduationCap, Gamepad2 } from "lucide-react";
import { SectionHead, FadeUp } from "@/components/Reveal";
import { PERSONAS } from "@/lib/content";

const ICONS = { briefcase: Briefcase, graduation: GraduationCap, gamepad: Gamepad2 };

export default function WhoNeeds() {
  return (
    <section className="relative py-24 sm:py-32 border-t border-white/5" data-testid="who-needs-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead eyebrow="Who needs it" title="Who needs an online mouse wiggler?" />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {PERSONAS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <FadeUp key={p.title} delay={i * 0.1} className="h-full">
                <article
                  data-testid={`persona-card-${i}`}
                  className="group h-full rounded-2xl border border-white/5 bg-surface overflow-hidden transition-colors duration-300 hover:border-neon/30"
                >
                  <div className="relative h-52 overflow-hidden">
                    <img
                      src={p.img}
                      alt={p.alt}
                      loading="lazy"
                      decoding="async"
                      data-testid={`persona-image-${i}`}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-surface via-transparent to-transparent" />
                    <div className="absolute bottom-4 left-5 w-10 h-10 rounded-xl bg-ink border border-neon/30 flex items-center justify-center">
                      <Icon size={17} className="text-neon" />
                    </div>
                  </div>
                  <div className="p-7">
                    <h3 className="font-display font-bold text-xl text-white tracking-tight">{p.title}</h3>
                    <p className="mt-3 text-mist text-[15px] leading-relaxed">{p.copy}</p>
                    <div className="mt-5 flex flex-wrap gap-2">
                      {p.tags.map((t) => (
                        <span key={t} className="font-mono text-[10px] uppercase tracking-[0.16em] text-mist border border-white/10 rounded-full px-3 py-1.5">
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                </article>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
